import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MapaComponent } from '../mapa/mapa.component';
import { PraiaService } from '../../services/info-locais/praia/praia.service';
import { ParqueService } from '../../services/info-locais/parque/parque.service';

@Component({
  selector: 'app-info-card',
  standalone: true,
  imports: [RouterModule, CommonModule, MapaComponent],
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss'],
})
export class InfoCardComponent implements OnInit {
  @ViewChild(MapaComponent) mapaComponent!: MapaComponent;

  loading: boolean = true;
  currentPage: number = 1;
  itemsPerPage: number = 12;
  totalPages: number = 1;
  paginatedItems: any[] = [];
  paginationDots: number[] = [];
  pageTitle: string | null = null;
  data: any;
  local: any;
  praias: boolean = false;
  parques: boolean = false;
  locations: { latitude: number, longitude: number }[] = [];
  bannerImage: string | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private praiaService: PraiaService,
    private parqueService: ParqueService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.pageTitle = params.get('name');
      this.bannerImage = this.route.snapshot.paramMap.get('image');
      this.infoPagina();
    });
    if (this.mapaComponent) {
      this.mapaComponent.resetMap();
    }
  }

  infoPagina() {
    if (this.pageTitle === 'Praias') {
      this.praias = true;
      this.obterInfoPraia();
    } else if (this.pageTitle === 'Parques') {
      this.parques = true;
      this.obterInfoParque();
    }
  }

  obterInfoParque() {
    this.loading = true;
    this.parqueService.getParque().subscribe({
      next: (res: any) => {
        this.paginatedItems = res;
        this.locations = res.map((item: any) => ({
          latitude: item.latitude,
          longitude: item.longitude,
        }));
        this.loading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.loading = false;
      },
    });
  }

  obterInfoPraia() {
    this.loading = true;
    this.praiaService.getPraia().subscribe({
      next: (res: any) => {
        this.paginatedItems = res;
        this.locations = res.map((item: any) => ({
          latitude: item.latitude,
          longitude: item.longitude,
        }));
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      },
    });
  }

  navigateToInfo(name: string) {
    this.router.navigate([`/info/${name}`]);
  }
}
